<template>
  <div>
    <div :style="'display: flex; flex-direction: column; justify-content: '+(align ? align : 'center')+'; align-items: '+(align ? align : 'center')+'; '+(!notopmargin ? 'top: 0px; ' : '')+'position: relative;;'">
        <el-image v-if="isImage" @click="dialogVisible = true" :src="getImagePath" :style="'width: '+image_width+'px;'">
            <div slot="placeholder" class="image-slot">
                Loading<span class="dot">...</span>
            </div>
        </el-image>
        <a v-else :href="getImagePath" target="_blank">
            <img src="https://donquijote.b-cdn.net/eventsonline/pdf.png" :style="{width: image_width+'px'}" alt="">
        </a>
        <div v-if="!hide_upload" style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <a @click="openFileDialog" style="cursor: pointer; margin-left: 20px;">
                <i :class="$store.getters.getLoadingState ? 'el-icon-loading' : 'el-icon-upload'" style="font-size: 24px;"></i>
            </a>
            <!--<a @click="camera_visible=true" style="cursor: pointer; margin-left: 20px;">
                <i :class="$store.getters.getLoadingState ? 'el-icon-loading' : 'el-icon-camera-solid'" style="font-size: 24px;"></i>
            </a>-->
                          
            <!--<el-button :loading="$store.getters.getLoadingState" @click="openFileDialog" size="small" :style="button_style" icon="el-icon-upload"></el-button>
            <el-button :loading="$store.getters.getLoadingState" @click="openFileDialog" size="small" :style="button_style" icon="el-icon-camera-solid"></el-button>        -->
        </div>
        <input type="file" v-if="!hide_upload" :id="file_dialog_id" @change="uploadImageToCDN" :accept="allow_pdf ? '*' : 'image/*;capture=camera'" style="display: none;">        
        <span v-if="allow_pdf" style="top: 5px; position: relative;">
            If pdf, (max size <b>50 mb</b>)
        </span>
    </div>  
    <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        width="70%">
        <div style="width: 100%; text-align: center;">
            <img :src="getImagePath" alt="" style="max-width: 100%;">
        </div>
    </el-dialog>

    <!--<el-dialog
        v-if="camera_visible"
        :visible.sync="camera_visible"
        append-to-body
        width="70%">
        <div style="width: 100%; text-align: center; display: flex; flex-direction: column;">
            <WebCam :ref="'webcam'" width="200px" height="200px"  @camera:captured="getImage" ></WebCam>
                <button type="button" 
                    class="btn btn-primary" 
                    @click="onCapture">Capture Photo</button>
    
        </div>
    </el-dialog>-->
      
  </div>
</template>

<script>
import axios from 'axios'
import * as accessTokenInfo from "../store/accessToken";
import { WebCam } from "vue-web-cam";

export default {
    props: ['image_path', 'image_width', 'file_dialog_id', 'button_style', 'hide_upload', 'align', 'notopmargin', 'allow_pdf'],
    components: {WebCam},
    data() {
        return {
            uploaded_image_path: 'https://etacdn.b-cdn.net/website/blank_image.png',
            dialogVisible: false,
            camera_visible: false
        }
    },
    computed: {
        isImage() {
            let imagePath = this.getImagePath.toLowerCase()

            if(imagePath.length === 0) {
                return true
            }
            return imagePath.indexOf('.png')>=0 
                || imagePath.indexOf('.jpg')>=0 
                || imagePath.indexOf('.jpeg')>=0 
                || imagePath.indexOf('.gif')>=0 
                || imagePath.indexOf('.svg')>=0 
        },
        getImagePath() {
            
            if(this.image_path != null && this.image_path.length>0) {
                return this.image_path    
            }
            return this.uploaded_image_path
        }
    },
    methods: {
        onCapture() {
          this.$refs.webcam.capture();
          
        },
        getImage(data) {
            this.uploaded_image_path = data
            this.sendImageBack()
        },
        openFileDialog() {
            document.getElementById(this.file_dialog_id).click()
        },
        convertJPGtoJPEG(file) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                const reader = new FileReader();
                reader.onload = (e) => {
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        const ctx = canvas.getContext("2d");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        ctx.drawImage(img, 0, 0);

                        canvas.toBlob((blob) => {
                            if (!blob) return reject("Conversion failed");

                            const newFile = new File(
                                [blob],
                                file.name.replace(/\.jpg$/i, ".jpeg"),
                                { type: "image/jpeg" }
                            );
                            resolve(newFile);
                        }, "image/jpeg", 0.92);
                    };
                    img.src = e.target.result;
                };
                reader.readAsDataURL(file);
            });
        },
        async uploadImageToCDN() {

            this.$store.commit('toggleLoadingState', true)
            let formData = new FormData();
            
            const file = document.getElementById(this.file_dialog_id).files[0];

            if (/\.jpg$/i.test(file.name)) {
                const converted = await this.convertJPGtoJPEG(file);
                formData.append("file", converted);
            } else {
                formData.append("file", file);
            }

            //const newFile = new File([file], file.name.replace(/\.jpg$/i, '.jpeg'), {
              //  type: file.type === "image/jpg" ? "image/jpeg" : file.type
            //});

            //data.append('file', newFile);
            
            axios.post('/uploadFile/index.php', formData, accessTokenInfo.accessTokenInfo())
            .then(res => {
                console.log(JSON.stringify(res.data))
                if(res.data.status) {
                    this.uploaded_image_path = res.data.image_path
                    this.sendImageBack()
                } else {
                    this.$store.commit('displayMessageAlert', {message: 'Failed to upload!!!', type: 'Error'})
                }

            })
            .catch(error => {
                this.$store.commit('displayMessageAlert', {message: error, type: 'Error'})
            }).finally( () => {
                this.$store.commit('toggleLoadingState', false)
            })

        },
        sendImageBack() {
            
            this.$emit('uploaded', this.uploaded_image_path)
            
        }
    },
    
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/UploadFile.vue